module.exports = __webpack_public_path__ + "static/images/flag-philippines.3UYov1e.svg";